//export const api = 'http://127.0.0.1:9000';

export const api = 'https://fdbkserver.com';